import { useState, useEffect } from "react";
import config from "../../config";
import { encryptData } from "../../utils/cryptoUtils";

const CamEnachDetailsPage = ({ leadId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [enachDetails, setEnachDetails] = useState([]);

  useEffect(() => {
    if (!leadId) return;

    const getEnachDetails = async () => {
      try {
        setLoading(true);

        const response = await fetch(
          `${config.API_BASE_URL}get_enach_upi_mandate_details`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: encryptData({
              lead_id: leadId,
            }),
          }
        );

        const result = await response.json();

        if (result.success) {
          setEnachDetails(Array.isArray(result.data) ? result.data : []);
          setError("");
        } else {
          setEnachDetails([]);
          setError(result.message);
        }
      } catch (e) {
        setEnachDetails([]);
        setError("Something went wrong while fetching eNach details.");
      } finally {
        setLoading(false);
      }
    };

    getEnachDetails();
  }, [leadId]);

  if (loading) {
    return <div className="text-center p-3">Loading...</div>;
  }

  return (
    <div className="row">
      <div className="col-md-12">

        {error && (
          <div className="text-danger text-center mb-3">
            {error}
          </div>
        )}

        {enachDetails.map((item, index) => {
          const mandate = item.mandate || {};

          return (
            <table
              key={index}
              className="table table-bordered table-hover mb-4"
            >
              <tbody>

                <tr>
                  <th colSpan="6" className="text-center">
                    eNach Details {index + 1}
                  </th>
                </tr>

                <tr>
                  <th>UMRN Number</th>
                  <td>{mandate.UMRNNumber || "N/A"}</td>

                  <th>e-NACH Set On</th>
                  <td>{item.created_at || "N/A"}</td>

                  <th>e-NACH First Debit Date</th>
                  <td>{mandate.schedule_date || "N/A"}</td>
                </tr>

                <tr>
                  <th>e-NACH Done By</th>
                  <td>{item.enach_done_by || "N/A"}</td>

                  <th>UPI Handles</th>
                  <td>
                    {Array.isArray(item.upi_handles) && item.upi_handles.length > 0
                        ? item.upi_handles.join(", ")
                        : "N/A"}
                    </td>

                  <th>No. of Vehicles</th>
                  <td>{item.no_of_vehicles || "N/A"}</td>
                </tr>

                <tr>
                  <th>Last Updated</th>
                  <td>{item.created_at || "N/A"}</td>
                  <td colSpan="4"/>
                </tr>

              </tbody>
            </table>
          );
        })}

        {!loading && enachDetails.length === 0 && (
          <div className="text-center py-4">
            No eNach Details Found.
          </div>
        )}

      </div>
    </div>
  );
};

export default CamEnachDetailsPage;